<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Negatori Genocida</h4>
          </md-card-header>
          <md-card-content>
            <cisti-negatori table-header-color="green"></cisti-negatori>
          </md-card-content>
        </md-card>
      </div>

    </div>
  </div>
</template>

<script>
import { CistiNegatori } from "@/components";

export default {
  components: {
    CistiNegatori
  }
};
</script>
